import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import App from './App';
import "./config/i18n";

ReactDOM.render(
  <Suspense fallback={<></>}>
    <App />
  </Suspense>,
  document.getElementById('root')
);

serviceWorker.unregister();